import axios from "axios";
import { authUrl } from "~/data/usecases/authentication/apiAuthentication";

export class HttpClient {
  constructor(baseUrl = "") {
    this.baseUrl = baseUrl;
    this.axios = axios.create({
      baseURL: this.baseUrl,
    });

    // Atualiza o token desta instância quando o re-login ocorre via Dialog
    this._onTokenRefresh = (event) => {
      this.setAuthorization(event.detail.token);
    };
    window.addEventListener("gt:token-refreshed", this._onTokenRefresh);

    this.axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (!error.response) {
          return Promise.reject(error);
        }
        const isAuthenticationEndpoint = error?.response?.request?.responseURL?.includes(authUrl);

        if (error?.response?.status === 401 && !isAuthenticationEndpoint) {
          window.dispatchEvent(new CustomEvent("unauthorized", { detail: error }));
        }

        return Promise.reject(error);
      }
    );
  }

  setAuthorization(accessToken) {
    this.axios.defaults.headers.Authorization = `Bearer ${accessToken}`;
  }

  clearAuthorization() {
    this.axios.defaults.headers.Authorization = "";
    window.removeEventListener("gt:token-refreshed", this._onTokenRefresh);
  }

  async request(request) {
    const axiosRequest = {
      url: request.url,
      data: request.data,
      params: request.params,
      method: request.method,
      headers: request.headers,
      responseType: request.responseType,
    };
    return this.axios.request(axiosRequest);
  }
}
